require("stylesheets/styles.scss");
require("scripts/main");

require.context("svg/", true);
require.context("img/", true);
